import React, {useState, useEffect, useContext} from 'react';
import AppContext from '../../context/Context';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/illustrations/falcon.png';
import qt from '../../assets/img/illustrations/qt.jpeg';

import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';

const Logo = ({ at = 'auth', width = 58, className, textClass, ...rest }) => {
  const [collapse, setCollapse] = useState(false);
  const {
    config: {isNavbarVerticalCollapsed },
  } = useContext(AppContext);

  useEffect(() => {
    if (isNavbarVerticalCollapsed !== undefined) {
      setCollapse(isNavbarVerticalCollapsed)
    }
  }, [isNavbarVerticalCollapsed])

  return (
    <Link
      to="/home"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center logo-vertical': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        {!collapse &&
            <span className={classNames(textClass, `d-${topNavbarBreakpoint}-block d-none`)} style={{ fontSize: '1.25rem'}}>
               {/* <img className="me-1" src={qt} alt="Logo"  /> */}
               <span className="quik">Quik</span><span className="trade">Trade</span>
            </span>
        }
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
  isNavbarVerticalCollapsed: PropTypes.bool,
};



export default Logo;
